import app from 'new-ui/app';
import { POPUP } from 'utils/constants/popup';

export const createUserFinance = ({
  redirectTo,
  subtitle,
} = {}) => {
  const onBeforeSignup = () => {
    app.showPreloader();
  };
  const onSignup = () => {
    app.hidePreloader();
    if (redirectTo) {
      window.location = redirectTo;
    }
    app.setPopup(false);
  };

  app.setPopup(POPUP.USER_SIGNUP, {
    theme: 'middle',
    onBeforeSignup,
    onSignup,
    subtitle,
  });
};
